import * as core from '../../../../../../../core'

import { query } from './open-edit-external-institution-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.external-institutions.open-edit-modal',
    description: 'Open Edit External Institution Modal',
    name: 'Open Edit External Institution Modal',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
